import clsx from "clsx"
import { FC, ReactNode } from "react"
import { SidebarMode, useSidebarMode } from "../../Contexts/SidebarMode/SidebarModeContext"

type PageLayoutProps = {
  children: ReactNode
  variant: PageLayoutVariant
}

export enum PageLayoutVariant {
  GLASS = "glass",
  WHITE = "white",
}

export const PageLayout: FC<PageLayoutProps> = ({ children, variant }) => {
  const { mode } = useSidebarMode()

  return (
    <main
      className={clsx(
        "min-h-screen grid",
        mode === SidebarMode.MOBILE && "px-4 py-8 mb-21",
        mode === SidebarMode.COLLAPSED && "py-3 pr-3 pl-0 mb-0 ml-21",
        mode === SidebarMode.EXPANDED && "py-3 pr-3 pl-0 mb-0 ml-60",
        variant === PageLayoutVariant.WHITE && "bg-neutral-white",
        variant === PageLayoutVariant.WHITE && mode !== SidebarMode.MOBILE && "bg-transparent"
      )}
    >
      <div
        className={clsx(
          "flex flex-col min-w-0",
          mode !== SidebarMode.MOBILE && "px-6 py-6 rounded-xl",
          variant === PageLayoutVariant.WHITE && "bg-neutral-white",
          variant === PageLayoutVariant.GLASS && mode !== SidebarMode.MOBILE && "bg-neutral-white/50"
        )}
      >
        {children}
      </div>
    </main>
  )
}
